"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var SuperCategory = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/groupTags/SuperCategory"));

var _default = [SuperCategory.MARKETING, SuperCategory.SALES, SuperCategory.CUSTOMER_SUCCESS, SuperCategory.PRODUCTIVITY, SuperCategory.FINANCE];
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/constants/superCategoryOrder.js
// module id = 262
// module chunks = 209 210 211 212